import ActivityCategory from "../../entities/activityCategory";

/**
 * ActivityCategory actions
 *
 * Call order:
 *
 * ACTIVITYCATEGORY_SAVE_QUEUE:	adds the item to the save queue
 * --> ACTIVITYCATEGORY_SAVE:	modifies the state
 * --> ACTIVITYCATEGORY_SAVE_SUCCESS: if all went well
 * --> ACTIVITYCATEGORY_SAVE_FAILURE:	if either the queue or local save failed
 *
 * Note that the only way to fail ACTIVITYCATEGORY_SAVE_QUEUE is during the call to ACTIVITYCATEGORY_SAVE,
 * as adding an item to the queue should never fail.
 */

export const ACTIVITYCATEGORY_FETCH_ONE_QUEUE: any = 'ACTIVITYCATEGORY_FETCH_ONE_QUEUE';
export const ACTIVITYCATEGORY_FETCH_SUCCESS: any = 'ACTIVITYCATEGORY_FETCH_SUCCESS';
export const ACTIVITYCATEGORY_FETCH_FAILURE: any = 'ACTIVITYCATEGORY_FETCH_FAILURE';
export const ACTIVITYCATEGORY_FETCH_ONE_SUCCESS: any = 'ACTIVITYCATEGORY_FETCH_ONE_SUCCESS';
export const ACTIVITYCATEGORY_FETCH_ONE_FAILURE: any = 'ACTIVITYCATEGORY_FETCH_ONE_FAILURE';

export const ACTIVITYCATEGORY_SAVE: any = 'ACTIVITYCATEGORY_SAVE';
export const ACTIVITYCATEGORY_SAVE_QUEUE: any = 'ACTIVITYCATEGORY_SAVE_QUEUE';
export const ACTIVITYCATEGORY_SAVE_SUCCESS: any = 'ACTIVITYCATEGORY_SAVE_SUCCESS';
export const ACTIVITYCATEGORY_SAVE_FAILURE: any = 'ACTIVITYCATEGORY_SAVE_FAILURE';

export const ACTIVITYCATEGORY_SAVE_MANY: any = 'ACTIVITYCATEGORY_SAVE_MANY';
export const ACTIVITYCATEGORY_SAVE_MANY_QUEUE: any = 'ACTIVITYCATEGORY_SAVE_MANY_QUEUE';
export const ACTIVITYCATEGORY_SAVE_MANY_SUCCESS: any = 'ACTIVITYCATEGORY_SAVE_MANY_SUCCESS';
export const ACTIVITYCATEGORY_SAVE_MANY_FAILURE: any = 'ACTIVITYCATEGORY_SAVE_MANY_FAILURE';

export const ACTIVITYCATEGORY_REMOVE: any = 'ACTIVITYCATEGORY_REMOVE';
export const ACTIVITYCATEGORY_REMOVE_QUEUE: any = 'ACTIVITYCATEGORY_REMOVE_QUEUE';
export const ACTIVITYCATEGORY_REMOVE_SUCCESS: any = 'ACTIVITYCATEGORY_REMOVE_SUCCESS';
export const ACTIVITYCATEGORY_REMOVE_FAILURE: any = 'ACTIVITYCATEGORY_REMOVE_FAILURE';

export const ACTIVITYCATEGORY_RESTORE: any = 'ACTIVITYCATEGORY_RESTORE';
export const ACTIVITYCATEGORY_RESTORE_QUEUE: any = 'ACTIVITYCATEGORY_RESTORE_QUEUE';
export const ACTIVITYCATEGORY_RESTORE_SUCCESS: any = 'ACTIVITYCATEGORY_RESTORE_SUCCESS';
export const ACTIVITYCATEGORY_RESTORE_FAILURE: any = 'ACTIVITYCATEGORY_RESTORE_FAILURE';

export const ACTIVITYCATEGORY_RESTORE_MANY: any = 'ACTIVITYCATEGORY_RESTORE_MANY';
export const ACTIVITYCATEGORY_REMOVE_MANY: any = 'ACTIVITYCATEGORY_REMOVE_MANY';

/* Fetch actions */
export const fetchActivityCategorySuccess = (activityCategories: ActivityCategory[], partial: boolean, lastFetch: number) => ({type: ACTIVITYCATEGORY_FETCH_SUCCESS, activityCategories, partial, lastFetch});
export const fetchActivityCategoryFailure = (err: any) => {
		console.error('ActivityCategoryAction: fetchActivityCategoryFailure', err);
		return {type: ACTIVITYCATEGORY_FETCH_FAILURE, err};
};
export const fetchOneActivityCategoryQueue = (activityCategoryId: string) => ({type: ACTIVITYCATEGORY_FETCH_ONE_QUEUE, activityCategoryId});
export const fetchOneActivityCategorySuccess = (activityCategory: ActivityCategory) => ({type: ACTIVITYCATEGORY_FETCH_ONE_SUCCESS, activityCategory});
export const fetchOneActivityCategoryFailure = (id: string, err: any) => {
		console.error('ActivityCategoryAction: fetchOneActivityCategoryFailure', err);
		return {type: ACTIVITYCATEGORY_FETCH_ONE_FAILURE, id, err};
};

/* Save actions */
export const saveActivityCategory = (activityCategory: ActivityCategory) => {
    // console.debug('⮂ ACTIVITYCATEGORY_SAVE action', activityCategory?.id);
    return {type: ACTIVITYCATEGORY_SAVE, activityCategory};
}
export const saveActivityCategoryQueue = (activityCategory: ActivityCategory, onQueued?: (saved: boolean) => void) => {
    // console.debug('⮂ ACTIVITYCATEGORY_SAVE_QUEUE action', activityCategory?.id);
    return {type: ACTIVITYCATEGORY_SAVE_QUEUE, activityCategory, onQueued};
}
export const saveActivityCategorySuccess = (activityCategory: ActivityCategory) => {
    // console.debug('⮂ ACTIVITYCATEGORY_SAVE_SUCCESS action', activityCategory?.id);
    return {type: ACTIVITYCATEGORY_SAVE_SUCCESS, activityCategory};
}
export const saveActivityCategoryFailure = (activityCategory: ActivityCategory, status: number, message: string) => {
    console.warn(`⮂ ACTIVITYCATEGORY_SAVE_FAILURE error saving activityCategory: HTTP ${status}: ${message}`, activityCategory?.id);
    return {type: ACTIVITYCATEGORY_SAVE_FAILURE, activityCategory, status, message};
};

/* SaveMany actions */
export const saveManyActivityCategories = (activityCategories: ActivityCategory[]) => {
    // console.debug('⮂ ACTIVITYCATEGORY_SAVE_MANY action', activityCategories?.map(activityCategory => activityCategory?.id).join(','));
    return {type: ACTIVITYCATEGORY_SAVE_MANY, activityCategories};
}
export const saveManyActivityCategoriesQueue = (activityCategories: ActivityCategory[], onQueued?: (saved: boolean) => void) => {
    // console.debug('⮂ ACTIVITYCATEGORY_SAVE_MANY_QUEUE action', activityCategories?.map(activityCategory => activityCategory.id).join(','));
    return {type: ACTIVITYCATEGORY_SAVE_MANY_QUEUE, activityCategories, onQueued};
}

export const saveManyActivityCategoriesSuccess = (activityCategories: ActivityCategory[]) => {
    // console.debug('⮂ ACTIVITYCATEGORY_SAVE_MANY_SUCCESS action', activityCategories?.map(activityCategory => activityCategory.id).join(','));
    return {type: ACTIVITYCATEGORY_SAVE_MANY_SUCCESS, activityCategories};
}
export const saveManyActivityCategoriesFailure = (activityCategories: ActivityCategory[], status: number, message: string) => {
		console.warn(`⮂ SAVE_MANY_ACTIVITYCATEGORIES_FAILURE Error saving activityCategories: HTTP ${status}: ${message}`, activityCategories?.map(activityCategory => activityCategory.id).join(','));
		return {type: ACTIVITYCATEGORY_SAVE_MANY_FAILURE, activityCategories, status, message};
};

/* Remove actions */
export const removeActivityCategory = (activityCategory: ActivityCategory) => ({ type: ACTIVITYCATEGORY_REMOVE, activityCategory });
export const removeActivityCategoryQueue = (activityCategory: ActivityCategory) => ({ type: ACTIVITYCATEGORY_REMOVE_QUEUE, activityCategory });
export const removeActivityCategorySuccess = (activityCategory: ActivityCategory) => ({ type: ACTIVITYCATEGORY_REMOVE_SUCCESS, activityCategory });
export const removeActivityCategoryFailure = (activityCategory: ActivityCategory, status: number, message: string) => {
	console.error(`Redux: removeActivityCategoryFailure Error removing activityCategory: HTTP ${status}: ${message}`);
	return ({ type: ACTIVITYCATEGORY_REMOVE_FAILURE, activityCategory, status, message });
};

/* Restore actions */
export const restoreActivityCategory = (activityCategory: ActivityCategory) => ({ type: ACTIVITYCATEGORY_RESTORE, activityCategory });
export const restoreActivityCategoryQueue = (activityCategory: ActivityCategory) => ({ type: ACTIVITYCATEGORY_RESTORE_QUEUE, activityCategory });
export const restoreActivityCategorySuccess = (activityCategory: ActivityCategory) => ({ type: ACTIVITYCATEGORY_RESTORE_SUCCESS, activityCategory });
export const restoreActivityCategoryFailure = (activityCategory: ActivityCategory, status: number, message: string) => {
	console.error(`Redux: restoreActivityCategoryFailure Error restoring activityCategory: HTTP ${status}: ${message}`);
	return ({ type: ACTIVITYCATEGORY_RESTORE_FAILURE, activityCategory, status, message });
};

/* RestoreMany actions */
export const restoreManyActivityCategories = (activityCategories: ActivityCategory[]) => ({ type: ACTIVITYCATEGORY_RESTORE_MANY, activityCategories });

/* RemoveMany actions */
export const removeManyActivityCategories = (activityCategories: ActivityCategory[]) => ({ type: ACTIVITYCATEGORY_REMOVE_MANY, activityCategories });